import { toast } from "react-toastify";

import { api } from "../../../utils/api";
import { getRegistrationType } from "../../GlobalRoles/getRegistrationTypes";

export const onSubmitEditRegistrationType = async (
  resetType,
  setLoading,
  setVisible,
  data,
) => {
  const notification = toast.loading("Alterando...");
  try {
    var id = data.id;
    setLoading(true);
    await api.put(`type-cli/${id}`, data);

    // Executar GetRegistrationType após a atualização bem-sucedida
    await getRegistrationType(setLoading);

    resetType();
    toast.update(notification, {
      render: "Tipo de Cadastro alterado com sucesso!",
      type: "success",
      theme: "colored",
      autoClose: 5000,
      isLoading: false,
    });
  } catch (e) {
    toast.update(notification, {
      render: "Não foi possivel fazer a alteração!",
      type: "error",
      theme: "colored",
      autoClose: 5000,
      isLoading: false,
    });
    resetType();
  } finally {
    setLoading(false);
    setVisible(false);
  }
};